import {isGoogleTagManagerEnabled} from './isGoogleTagManagerEnabled';

export function GoogleTagManagerBody() {
  if (!isGoogleTagManagerEnabled()) {
    return null;
  }

  const googleTagManagerId =
    (import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID as string | undefined)
      ?.trim() ?? '';

  return (
    <noscript>
      <iframe
        height="0"
        src={
          'https://www.googletagmanager.com/ns.html'
          + `?id=${googleTagManagerId}`
        }
        style={{display: 'none', visibility: 'hidden'}}
        title="Google Tag Manager"
        width="0"
      />
    </noscript>
  );
}
